export default __webpack_public_path__ + "static/media/push-pin 2.9d5bb478.svg";